import { Route, Routes, useMatch, useResolvedPath } from 'react-router-dom'

import SystemView from './SystemView'
import LineView from './LineView'
import { type ISavedStateRouteParams, SavedStateRouteParams } from './types'

const States = () => {
  const qraBasePath = useResolvedPath('')
    .pathname.split('/')
    .slice(0, -1)
    .join('/')

  const matchState = useMatch(`${qraBasePath}/states/:stateId/*`)
  const matchAssessment = useMatch(
    `${qraBasePath}/states/:stateId/assessments/:assessmentId/*`
  )

  if (matchState?.params == null) {
    return <div>Invalid or missing State/Assessment IDs!</div>
  }

  const routeParams: ISavedStateRouteParams = {
    [SavedStateRouteParams.StateId]: matchState.params.stateId!,
    [SavedStateRouteParams.AssessmentId]: matchAssessment?.params.assessmentId
  }

  return (
    <Routes>
      <Route
        path=':stateId/assessments/:assessmentId/line/:lineId/*'
        element={
          <LineView
            qraBasePath={qraBasePath}
            stateId={routeParams.stateId}
            assessmentId={routeParams.assessmentId}
          />
        }
      />
      <Route
        path=':stateId/line/:lineId/*'
        element={
          <LineView
            qraBasePath={qraBasePath}
            stateId={routeParams.stateId}
            assessmentId={routeParams.assessmentId}
          />
        }
      />
      <Route
        path=':stateId/assessments/:assessmentId/*'
        element={
          <SystemView
            qraBasePath={qraBasePath}
            stateId={routeParams.stateId}
            assessmentId={routeParams.assessmentId}
          />
        }
      />
      <Route
        path=':stateId/*'
        element={
          <SystemView
            qraBasePath={qraBasePath}
            stateId={routeParams.stateId}
            assessmentId={routeParams.assessmentId}
          />
        }
      />
    </Routes>
  )
}

export default States
